import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { ActivatedRoute } from '@angular/router';
import { FilterService } from '../../services/filter.service';
import { Observable } from 'rxjs';
import { JobService } from '../../services/jobs/job.service';
import * as _ from 'lodash';
import { ExamsService } from 'src/app/services/exams.service';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-exams-results',
  templateUrl: './exams-results.component.html',
  styleUrls: ['./exams-results.component.scss']
})

export class ExamsResultsComponent implements OnInit {
  job;
  learners: any = []; 
  newData = [];
  length;
  pageSizeOptions: number[] = [25, 50, 100];
  jobId;
  // displayedColumns: string[] = ['name', 'exam1', 'exam2'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  currentUser;
  loading: Boolean;
  isClient: boolean;
  afterFilter: any;
  tempExams = []
  disabled: boolean;
  totalSize: any;
  examList = new FormControl('');
  exams: any;
  pgIndex: any = 0;
  pgSize: any = 10;
  activeSort: any;
  sortDirection: any;
  columnsCopy: any[];
  inputDisable: boolean;

  columns = [];
  examFilter = [];
  user;
  response;

  displayedColumns;
  noDataMsg = {
    title: "No Learners!",
    data: "You have not yet added any learners"
  }
  noExamMsg = {
    title: "No Exams!",
    data: "You have not yet added total exams count"
  }

  @Input('jo') isActive: Boolean;
  @Input('jobId') jobIdFromClient;
  @Input('callGetMarks') callGetMarks;
  @Output() getLearnersFromComponent: EventEmitter<any> = new EventEmitter<any>();
  @Output() learnerAdded: EventEmitter<any> = new EventEmitter<any>();
  totalLearners: number;
  examsLength: any;
  displayTbl: boolean = false;


  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  private learnerRemove: Subject<any> = new Subject<any>();
  private addLearnerSubscription: Subject<any> = new Subject<any>();

  constructor(public _learnerService: LearnerService, public _examService: ExamsService,
    public dialog: MatDialog, public _filter: FilterService, public _snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, private _jobService: JobService) {
    this.learners = [];
    this.dataSource = new MatTableDataSource(this.learners);
    this._learnerService.newLearnerObservable().
      pipe(
        takeUntil(this.addLearnerSubscription)
      ).
      subscribe((newLeaner) => {
        let learner = {
          // exam1: newLeaner.learner.exam1,
          // exam2: newLeaner.learner.exam2,
          name: newLeaner.learner.name,
          learnerId: newLeaner.learner._id
        }

        for (let i = 0; i < this.exams.length; i++) {
          learner[this.exams[i]] = ""
        }

        this.response.learners.push(learner);




        if (this.examsLength > 0) {
          this.updateData(this.response.learners)
        }


        console.log("New learner added outside", newLeaner);
        console.log("final learner list", this.response.learners);

        // this.getMarks()
      });



    this._learnerService.removeLearnerObservable()
      .pipe(
        takeUntil(this.learnerRemove)
      ).subscribe((learner) => {
        console.log("when learner remove from job", learner);
        console.log("value of all learner data", this.response.learners);

        let index = this.response.learners.findIndex(x => x.learnerId === learner._id);
        console.log("what is index", index);

        if (index > -1) {
          this.response.learners.splice(index, 1)
          console.log("after learner remove in assignment page", this.response.learners);
        }
        if (this.examsLength > 0) {
          this.updateData(this.response.learners)
        }
      })

  }

  ngOnDestroy() {
    this.learnerRemove.next();
    this.learnerRemove.complete();
    this.addLearnerSubscription.next();
    this.addLearnerSubscription.complete();
  
    console.log("this.learnerRemove!!!",(!this.learnerRemove.closed))
  }



  ngOnInit() {
    console.log("jobIdFromClient", this.jobIdFromClient);
    this.loading = true;
    if (this.jobIdFromClient != undefined) {
      this.jobId = this.jobIdFromClient
      // this.getMarks()
    }
    else {
      this.activatedRoute.params.subscribe(params => {
        this.jobId = params['jobid'];
        console.log("Calling getLearnersFromComponent with jobid = ", this.jobId);
        this.getMarks()
      })
    }
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))

    if (this.user.isClient) {
      this.inputDisable = true;
    } else {
      this.inputDisable = false;
    }
    this.isClient = this.user.isClient ? true : false
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes in exam!!!", changes);
    if (changes.jobIdFromClient && changes.jobIdFromClient.currentValue) {
      this.displayedColumns = []
      this.columns = []
      this.jobId = changes.jobIdFromClient.currentValue
      this.getMarks()
    }
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(searchText) {
    if (this.totalLearners > 0) {
      this.afterFilter = null
      console.log('FILTER CALLED', searchText);
      if (searchText === '') {
        this.updateData(this.response.learners)
      }
      let filteredCourses = this._filter.filter(searchText, this.response.learners, ['name']);
      this.updateData(filteredCourses)
      if (filteredCourses.length <= 0) {
        this.afterFilter = {
          title: "No Learners!",
          data: "Sorry, no learners matched your search"
        }
        // this.afterFilter = "No learner with matched search text found!"
      }
    }
  }

  commentsChanged(event) {

    console.log('Comments Changed', event);

  }

  marksChanged(event) {
    console.log("MARKS CHANGED", event.event, event.column, event.row)
    let reg = new RegExp("^[0-9]{0,4}$");
    console.log("reg.test(event)", reg.test(event.event))
    if (reg.test(event.event)) {
      let examObj = {
        title: event.column,
        marks: event.event
      }

      let learner = _.find(this.tempExams, function (o) { return o.learnerId == event.row.learnerId })
      if (learner) {
        console.log("learner found", learner)
        console.log("exams", this.tempExams['exams'])
        let examIndex = _.findIndex(learner.exams, function (o) { return o.title == event.column })
        if (examIndex > -1) {
          console.log("learner examIndex found")
          learner.exams[examIndex] = examObj
        }
        else {
          console.log("learner examIndex NOT found")
          learner.exams.push(examObj)
        }
      }
      else {
        console.log("learner NOT found")
        let obj = {
          name: event.row.name,
          jobId: this.jobId,
          learnerId: event.row.learnerId,
          exams: [examObj]
        }

        this.tempExams.push(obj)
      }
      console.log("TEMP ARRAY IS", this.tempExams)

    }
    else {
      console.log("Not Valid")
      this.disabled = true;
    }

  }
  examChanged(event) {
    console.log('examChanged event', event)
    this.examFilter = event.value
  }
  save(learner) {
    // this.loading = true;

    // if (!this.disabled){
    console.log("form valid")
    this._examService.addExamInJob(this.tempExams).subscribe(res => {
      this.loading = false;
      this.openSnackBar("Marks updated successfuly!", 'OK')
      console.log("resresresresresresres", res)
      this.response = res.response
      // this.totalSize = marks.response.metadata[0].total
      this.exams = res.response.examHeaders
      this.totalLearners = res.response.learners.length
      // let temp = ['name']
      // temp = temp.concate(this.exams)
      // this.displayedColumns = this.temp;
      this.displayedColumns = ['name']
      this.displayedColumns = this.displayedColumns.concat(this.exams)
      this.columnsCopy = this.displayedColumns
      this.updateData(this.response.learners)
      // this.loading = false;
      // this.columns = this.displayedColumns
      console.log("this.displayedColumns", this.displayedColumns)
      // this.generateColumns(marks.response.maxExam)
    })
    // }
    // else{
    // this.openSnackBar("Please enter only numbers!", 'OK')
    // }

  }

  openedChange(event) {
    console.log("openedChange", event)
    console.log("columns", this.columns)
    let temp = this.examFilter
    if (this.examFilter.length > 0 && !event) {
      const result = this.columnsCopy.filter(x => temp.includes(x.toString()))
      console.log("result", result)
      this.displayedColumns = ["name"]
      this.displayedColumns = this.displayedColumns.concat(result)
    }
    else if (this.examFilter.length == 0 && !event) {
      this.displayedColumns = []
      this.displayedColumns = this.columnsCopy
    }
  }

  // Utility functions
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  updateData(learners) {
    console.log("UPDATING DATA = ", learners)
    console.log("Emitting event getLearnersFromComponent with learners = ", learners);
    this.getLearnersFromComponent.emit({ learners })
    this.dataSource = new MatTableDataSource(learners);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("DATASOURCE", this.dataSource)
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)

  }



  // API CALLS

  // getLearners(jobId) {
  //   let that = this;
  //   console.log("Getting learners for jobid = ", jobId);
  //   this._learnerService.getLearnersByJobId(jobId).subscribe((learners) => {
  //     this.learners = learners;
  //     this.loading = false;
  //     console.log("GOT LeARNERS=============>", learners);
  //     // this.updateData(learners)
  //   });
  // }
  // getJob(jobId) {
  //   let that = this;
  //   console.log("Getting JOB for jobid = ", this.jobId);
  //   this._jobService.getJobById(this.jobId).subscribe((jobs) => {
  //     console.log("Job Received = ", jobs);
  //     this.job = jobs.pop();
  //     console.log({ job: this.job });
  //   });
  // }

  getMarks() {
    this._examService.getExamMarks(this.jobId).subscribe((marks) => {
      console.log("MARKS DATA IN JOB", marks.response)
      this.response = marks.response
      // this.totalSize = marks.response.metadata[0].total
      this.exams = marks.response.examHeaders
      this.examsLength = marks.response.examHeaders.length
      if (this.examsLength > 0) {
        this.displayTbl = true
      }
      console.warn("this.examsLengththis.examsLength", this.examsLength)
      console.log("display variable value", this.displayTbl);

      console.log("value of total array response", this.response);


      this.totalLearners = marks.response.learners.length
      // let temp = ['name']
      // temp = temp.concate(this.exams)
      // this.displayedColumns = this.temp;
      this.displayedColumns = ['name']
      this.displayedColumns = this.displayedColumns.concat(this.exams)
      this.columnsCopy = this.displayedColumns
      if (this.examsLength > 0) {
        this.updateData(this.response.learners)
      } else {
        this.updateData([])
      }
      this.loading = false;
      // this.columns = this.displayedColumns
      console.log("this.displayedColumns", this.displayedColumns)
      this.callGetMarks = false;
      // this.generateColumns(marks.response.maxExam)
    })
  }
}